export default "__VITE_ASSET__CoFLHWGn__"